import { render, staticRenderFns } from "./member-redesign.vue?vue&type=template&id=523ff928&"
import script from "./member-redesign.vue?vue&type=script&lang=js&"
export * from "./member-redesign.vue?vue&type=script&lang=js&"
import style0 from "./member-redesign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('523ff928')) {
      api.createRecord('523ff928', component.options)
    } else {
      api.reload('523ff928', component.options)
    }
    module.hot.accept("./member-redesign.vue?vue&type=template&id=523ff928&", function () {
      api.rerender('523ff928', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/work/member-redesign.vue"
export default component.exports